/*
 * Awhi — testimonials carousel (Phase 3 home kit).
 * Scroll-snap track; arrows page by one card. Arrows disable at the
 * ends and the whole nav hides when nothing overflows.
 */
(function () {
  'use strict';

  function initCarousel(root) {
    if (root.dataset.awhiTmInit) return;
    root.dataset.awhiTmInit = '1';

    var track = root.querySelector('[data-awhi-tm-track]');
    var prev = root.querySelector('[data-awhi-tm-prev]');
    var next = root.querySelector('[data-awhi-tm-next]');
    var nav = root.querySelector('[data-awhi-tm-nav]');
    if (!track || !nav) return;

    function cardStep() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function sync() {
      var overflow = track.scrollWidth - track.clientWidth;
      nav.hidden = overflow < 8;
      if (prev) prev.disabled = track.scrollLeft < 8;
      if (next) next.disabled = track.scrollLeft > overflow - 8;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
    }

    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(sync, 80);
    });
    window.addEventListener('resize', sync);
    sync();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-awhi-tm]');
    for (var i = 0; i < roots.length; i++) initCarousel(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
